import { Injectable } from "@angular/core";
const alasql = require('alasql');
const XLSX = require('xlsx');

alasql.utils.isBrowserify = false;
alasql.utils.global.XLSX = XLSX;

@Injectable()
export class ExcelService {

    exportToExcel(query: string, data: any[]) {
        alasql(query, data);
    }
}
